import { render } from "./ProgramComponent.vue?vue&type=template&id=38697ba6"
import script from "./ProgramComponent.vue?vue&type=script&lang=js"
export * from "./ProgramComponent.vue?vue&type=script&lang=js"

import "./ProgramComponent.vue?vue&type=style&index=0&id=38697ba6&lang=css"

import exportComponent from "D:\\Projects\\SCFHSHealthAcademy\\SCFHSHealthAcademyPublic\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__